// extracted by mini-css-extract-plugin
export default {"container":"ConfirmEmailPendingPage_container__-flwj","center":"ConfirmEmailPendingPage_center__Zx4xp"};